const getTopicFilterHashValue = (topicName: string) => {
  const normalizedTopicName = topicName.trim().toLowerCase();

  if (normalizedTopicName === 'technology and data' || normalizedTopicName === 'technology & data') {
    return ['Technology and Data', 'Technology & Data'].map(encodeURIComponent).join(',');
  }

  return encodeURIComponent(topicName);
};

export const appendTopicFilterHash = (url?: string, topicName?: string) => {
  if (!url || !topicName) return url;

  const [baseUrl] = url.split('#');
  return `${baseUrl}#f-commontopics=${getTopicFilterHashValue(topicName)}`;
};

export const getInternalRoute = (url?: string) => {
  if (!url) return null;

  if (url.startsWith('/')) {
    return url;
  }

  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const targetUrl = new URL(url, window.location.origin);
    if (targetUrl.origin === window.location.origin) {
      return `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
    }
  } catch (e) {
    return null;
  }

  return null;
};
